export const getBuySellColor = (val: any) => {
    if (val === 0) {
        return "text-text_2";
    } else if (val > 0) {
        return "text-text_buy";
    } else {
        return "text-text_sell";
    }
};

export function getTextSize(
    totalLen: number,
    fS = 48,
    lH = 53,
    LEN = 8,
    sc = 0.7
) {
    //const sc = 0.7
    //const fS = 44
    //const lH = 53
    //const LEN = 8
    let fontSize;
    let lineHeight;

    if (totalLen <= LEN) {
        fontSize = `${fS}px`;
        lineHeight = `${lH}px`;
    } else {
        fontSize = `${Math.max(LEN, fS - Math.ceil(totalLen / sc))}px`;
        lineHeight = `${Math.max(LEN, lH - Math.ceil(totalLen / sc))}px`;
    }
    //console.log('totalLen: ' + totalLen, Math.ceil(totalLen / sc))
    //console.log('fontSize: ' + fontSize)
    return {
        fontSize,
        lineHeight,
    };
}
